import * as Sentry from '@sentry/react';

const environments: string[] = ['dev', 'uat', 'production'];

if (environments.includes(import.meta.env.VITE_SENTRY_ENV)) {
  Sentry.init({
    environment: import.meta.env.VITE_SENTRY_ENV,
    dsn: import.meta.env.VITE_SENTRY_DSN,
    // Axios rejects aborted requests with CanceledError; these are intentional
    // cancellations (AbortControllerManager), not failures.
    ignoreErrors: [/^CanceledError: /],
  });
}
